import type { IP_API_DTO } from "../types";
import fetcher from "../utils/fetcher.ts";

/**
 * Fetches geolocation information based on the client's IP address using the ipapi.co service.
 * If the request fails, returns a default UK calling code.
 *
 * API Endpoint: https://ipapi.co/json/
 * Rate Limit: 1000 requests per day (free tier)
 *
 * @returns {Promise<IP_API_DTO>} Object containing IP geolocation data, including:
 *   - country_calling_code: International calling code (e.g., "+44")
 *   - plus other fields defined in IP_API_DTO interface
 * @throws {Error} Caught and handled internally, returns default object
 */
export function getIPInfo() {
  return fetcher<IP_API_DTO>("https://ipapi.co/json/").catch(() => {
    return { country_calling_code: "+44" };
  });
}
